import { observer } from "mobx-react";

import ShowModal from "@component/ShowModal";
import PersonalDocument from "@model/PersonalDocument";
import PersonalDocumentShowVM from "@vm/Show/PersonalDocument";
import Form from "./Form";

import { lazyInject, TYPES } from "../../../../inversify.config";

@observer
export default class PersonalDocumentShowModal extends ShowModal<PersonalDocument> {
  modelName = "personal_document";
  prefix = "employee.personal_information";

  @lazyInject(TYPES.PersonalDocumentShow)
  vm: PersonalDocumentShowVM;

  onClose = () => {
    this.router.pageLink(this.uriHelper.employees_personal_data(this.props.match.params.user_id));
  };

  setIdFromParams() {
    this.vm.init(this.getId(), this.props.match.params.user_id);
  }

  renderModalBody() {
    return <Form entity={this.vm.entity} vm={this.vm.personalDocumentFormVM} readonly={true} />;
  }
}
